// Pure formatting for the peek card (S2), so it can be tested without React.
import {
	displayDistanceKm,
	distanceMeters,
	timeWindowFor,
	type LatLng,
	type Locale,
} from '@spot/shared';

export type DayKind = 'today' | 'tomorrow' | 'other';

/** Today / tomorrow in the city's timezone (not the device's). */
export function dayKind(startAt: Date, now: Date, timeZone: string): DayKind {
	const inside = (when: 'today' | 'tomorrow') => {
		const { start, end } = timeWindowFor(when, timeZone, now);
		return startAt >= start && startAt < end;
	};
	if (inside('today')) return 'today';
	if (inside('tomorrow')) return 'tomorrow';
	return 'other';
}

/** «Сьогодні · 19:00», «Завтра · 09:30», «сб, 18 жовт. · 12:00». */
export function timeBadge(
	startAt: Date,
	options: {
		now: Date;
		timeZone: string;
		locale: Locale;
		today: string;
		tomorrow: string;
	},
): string {
	const time = new Intl.DateTimeFormat(options.locale, {
		timeZone: options.timeZone,
		hour: '2-digit',
		minute: '2-digit',
		hourCycle: 'h23',
	}).format(startAt);
	const kind = dayKind(startAt, options.now, options.timeZone);
	const day =
		kind === 'today'
			? options.today
			: kind === 'tomorrow'
				? options.tomorrow
				: new Intl.DateTimeFormat(options.locale, {
						timeZone: options.timeZone,
						weekday: 'short',
						day: 'numeric',
						month: 'short',
					}).format(startAt);
	return `${day} · ${time}`;
}

/**
 * Distance in km shown to the viewer (PRIVACY rule 2): from their rounded position to the
 * point the API gave for drawing (the cell center for personal events), rounded to 0.5 km.
 */
export function distanceKm(viewer: LatLng | null, eventPoint: LatLng): number | null {
	return viewer === null ? null : displayDistanceKm(distanceMeters(viewer, eventPoint));
}
